<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`试验数据填写【${this.activeInfo.reportCode}】【${this.activeInfo.projectName}】`"
    width="100vw"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <keep-alive>
      <component v-loading="dataLoading" ref="templateComponent" class="template-common" :is="currentComponent"></component>
    </keep-alive>

    <div slot="footer" class="dialog-footer">
      <div>
        <el-radio-group v-model="dataType" @change="handleDataType">
          <el-radio-button label="tdchd">涂镀层厚度</el-radio-button>
          <el-radio-button label="dxchd">镀锌层厚度</el-radio-button>
          <el-radio-button label="dychd">镀银层厚度</el-radio-button>
          <el-radio-button label="hd">厚度</el-radio-button>
          <el-radio-button label="ddl">导电率</el-radio-button>
        </el-radio-group>
      </div>

      <div>
        <el-button @click="$emit('update:visible', false)">关 闭</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
      </div>
    </div>
  </drag-dialog>
</template>

<script>
import ItemDXCHD from './sampleTemplate/ItemDXCHD';
import ItemDDL from './sampleTemplate/ItemDDL';
import ItemDYCHD from './sampleTemplate/ItemDYCHD';
import ItemHD from './sampleTemplate/ItemHD';
import ItemTDCHD from './sampleTemplate/ItemTDCHD';

import { editTotEntrustmentDataByItem } from '@/api/flow';

export default {
  components: {
    ItemDXCHD,
    ItemDYCHD,
    ItemHD,
    ItemTDCHD,
    ItemDDL
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dataLoading: false,
      dataType: 'tdchd',
      dataTypeOptions: [
        {
          label: '涂镀层厚度',
          value: 'tdchd',
          template: 'ItemTDCHD'
        },
        {
          label: '镀锌层厚度',
          value: 'dxchd',
          template: 'ItemDXCHD'
        },
        {
          label: '镀银层厚度',
          value: 'dychd',
          template: 'ItemDYCHD'
        },
        {
          label: '厚度',
          value: 'hd',
          template: 'ItemHD'
        },
        {
          label: '导电率',
          value: 'ddl',
          template: 'ItemDDL'
        }
      ],
      currentComponent: 'ItemTDCHD',
      submitLoading: false,
      testSampleList: []
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
      }
    }
  },
  methods: {
    // 获取原始数据回显信息
    async getFlowDeliverDetail() {},
    handleDataType() {
      this.currentComponent = this.dataTypeOptions.find(item => item.value === this.dataType).template;
    },
    // 定位到对应样品
    handleLocation() {},
    // 提交录入数据
    async handleSubmit() {
      const writeSampleList =
        this.$refs.templateComponent.writeSampleList.map(item => {
          return {
            ...item,
            oriData: item.oriDataList
          };
        }) || [];
      if (!writeSampleList.length) return this.$message.error('请填写检测数据!');

      const params = {
        entrustmentId: this.activeInfo.id,
        itemList: writeSampleList
      };

      try {
        // await editTotEntrustmentDataByItem(params);

        this.$message.success('提交成功!');
        this.$emit('refresh');
        this.$emit('update:visible', false);
      } finally {
        this.submitLoading = false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}

.search-item {
  margin-right: auto;

  .el-select {
    width: 220px;
    margin-right: 14px;
  }
}

.el-input,
.el-select {
  width: 100%;
}
</style>
